var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVayviene(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.11287 12.0603L1.14302 18.0301L7.11287 24L8.8182 22.2947L4.76111 18.0304L8.8182 13.7656L7.11287 12.0603ZM16.8817 0L15.1764 1.70533L19.2335 5.97008L15.1764 10.2344L16.8817 11.9397L22.8516 5.96985L16.8817 0Z",
    fill: "#002856"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVayviene);
export default __webpack_public_path__ + "static/media/va y viene.de69786c9d92cb57e80969a43110c69c.svg";
export { ForwardRef as ReactComponent };